import Graph from 'components/MatrixGraph/Graph';

export function graphFromTraces(edges) {
  const graph = new Graph();
  edges.forEach((edge) => graph.addEdge(edge));
  return graph;
}
